import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './Container';
export function Footer() {
  return <footer className="bg-brand-black text-brand-white pt-[80px] pb-[30px]" data-id="element-42" data-mp="3ggaohovss12a">
      <Container data-id="element-43" data-mp="32oe09vx92bb6">
        <div className="grid grid-cols-[1.5fr_1fr_1fr_1fr] max-[800px]:grid-cols-2 gap-[40px] pb-[60px] border-b border-white/20" data-id="element-44" data-mp="32ovz90bar3ms">
          <div data-id="element-45" data-mp="36nd4feb5q41k">
            <div className="text-[clamp(2rem,3.2vw,3.2rem)] font-black leading-[0.95] tracking-[-0.025em]" data-id="element-46" data-mp="36n3grxdl48z1">
              The Abie Agency.
              <br data-id="element-47" data-mp="37o6cv1anxdd" />
              For builders.
            </div>
          </div>

          <div data-id="element-48" data-mp="3levg4zwzhcf4">
            <h4 className="font-mono text-[12px] tracking-[0.18em] uppercase opacity-60 mb-[18px]" data-id="element-49" data-mp="3ldalzbekzvhs">
              Pages
            </h4>
            <div className="flex flex-col" data-id="element-50" data-mp="3qblyxv06am48">
              <Link to="/#work" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-51" data-mp="29ynldknsn5e0">
                Work
              </Link>
              <Link to="/#services" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-52" data-mp="3l9abhd1s8u1s">
                Services
              </Link>
              <Link to="/influencers" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-53" data-mp="3v7ggw4mssibe">
                Influencers
              </Link>
              <Link to="/about" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-54" data-mp="82ie9xijwigy">
                About
              </Link>
              <Link to="/#careers" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-55" data-mp="hsk1yo6zryvc">
                Careers
              </Link>
              <Link to="/contact" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-56" data-mp="qt8hjnc1a7ac">
                Contact
              </Link>
            </div>
          </div>

          <div data-id="element-57" data-mp="tw5yi6q9bqmq">
            <h4 className="font-mono text-[12px] tracking-[0.18em] uppercase opacity-60 mb-[18px]" data-id="element-58" data-mp="two2xqn2pb5q">
              Direct lines
            </h4>
            <div className="flex flex-col" data-id="element-59" data-mp="13taokhn8468t">
              <a href="mailto:hello@theabieagency.com" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-60" data-mp="13sipgwuf3qds">
                New business
              </a>
              <a href="mailto:press@theabieagency.com" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-61" data-mp="1clcjy1ifqwc8">
                Press
              </a>
              <a href="mailto:careers@theabieagency.com" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-62" data-mp="1mhpawrmliw3a">
                Careers
              </a>
            </div>
          </div>

          <div data-id="element-63" data-mp="3t9gew986t3l8">
            <h4 className="font-mono text-[12px] tracking-[0.18em] uppercase opacity-60 mb-[18px]" data-id="element-64" data-mp="3tb17htaxycgg">
              Social
            </h4>
            <div className="flex flex-col" data-id="element-65" data-mp="2agyeh6q4czor">
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-66" data-mp="25o56m9zctb8g">
                Instagram
              </a>
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-67" data-mp="1wo8q4vn4bioh">
                LinkedIn
              </a>
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-68" data-mp="2pcnsoip2c8ix">
                TikTok
              </a>
              <a href="#" className="py-[4px] text-[15px] hover:opacity-70 transition-opacity" data-id="element-69" data-mp="2kf4fzn80k3t3">
                YouTube
              </a>
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center pt-[28px] flex-wrap gap-[16px] text-[12px] opacity-60" data-id="element-70" data-mp="13yi84bid7wn3">
          <span data-id="element-71" data-mp="2ruoh999siq0h">© 2026 The Abie Agency. All Rights Reserved.</span>
          <span data-id="element-72" data-mp="2wm7md3irci3t">theabieagency.com</span>
        </div>
      </Container>
    </footer>;
}